import { Component } from 'react'
import { connect } from 'react-redux'
import { Pagination, Empty, Spin } from 'antd'
import { withTranslation } from 'react-i18next'
import CatalogItemCard from './catalog-item-card'
import CatalogItemsTable from './catalog-items-table'
import CatalogItemDefault from './catalog-item-default'
import { getRolename } from '../../lib/AuthUtils'
import { ROLES } from '../../constants/AuthConstants'
import {
  getProductsByLineaCatalogo,
  searchCatalogProducts,
  setFilterSelected,
  fetchDiagramDataRequest,
} from '../../actions'
import { PRODUCTS_RESULT_MODE } from '../../constants/DefaultUserConfig'
import withRouterParams from '../common/RouterUtils'
import DiagramModal from './DiagramModal'

const PARAM_FILTER = 'filtro'
const PARAM_LINEACATALOGOID = 'lineaCatalogoId'
const PARAM_SORT = 'orden'

class CatalogItems extends Component {
  constructor(props) {
    super(props)
    this.state = {
      diagramModalVisible: false,
      diagramModalItem: null,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.products !== this.props.products) {
      window.scrollTo(0, 0)
    }

    if (prevProps.sortColumn !== this.props.sortColumn) {
      const params = this.getParams()
      this.updateURL(
        {
          ...params,
          [PARAM_SORT]: this.props.sortColumn,
        },
        true,
      )
      this.props.setFilterSelected(this.props.sortColumn)
      this.handleChangeFilter()
    }
  }

  componentDidMount() {
    const { products, isSearching } = this.props
    const params = this.getParams()
    const order = params[PARAM_SORT] ? params[PARAM_SORT] : 'PC_ASC'
    const initialValues = {
      order: params[PARAM_SORT],
      filter: params[PARAM_FILTER] ? params[PARAM_FILTER] : '',
    }

    if (params[PARAM_LINEACATALOGOID]) {
      const lineParams = {
        lineaCatalogoId: params[PARAM_LINEACATALOGOID],
        order,
      }
      this.props.getProductsByLineaCatalogo(lineParams)
    }
    if (!isSearching && initialValues.filter && !params[PARAM_LINEACATALOGOID] && !products.data) {
      this.props.searchCatalogProducts(initialValues)
    }
  }

  handleChangeFilter = () => {
    const { searchRequest, selectedCatalogLine, products } = this.props
    const params = this.getParams()

    if (!params[PARAM_LINEACATALOGOID]) {
      this.props.searchCatalogProducts({
        ...searchRequest,
        order: params[PARAM_SORT] || searchRequest.order,
        page: products.page || 1,
      })
    } else {
      const query = {
        lineaCatalogoId: selectedCatalogLine,
        pageSize: 12,
        page: products.page || 1,
        order: params[PARAM_SORT] || searchRequest.order,
      }

      this.props.getProductsByLineaCatalogo(query)
    }
  }

  handleProductPageChange = (current, size) => {
    const { searchRequest, filterSelected } = this.props

    const params = this.getParams()
    window.scrollTo(0, 0)

    if (params[PARAM_FILTER]) {
      this.props.searchCatalogProducts({
        order: searchRequest.order,
        filter: searchRequest.filter,
        page: current,
        pageSize: size,
        lineaCatalogoIds: searchRequest.lineaCatalogoIds,
      })
    } else if (params[PARAM_LINEACATALOGOID]) {
      const query = {
        lineaCatalogoId: params[PARAM_LINEACATALOGOID],
        pageSize: size,
        page: current,
        order: filterSelected || 'PC_ASC',
      }
      this.props.getProductsByLineaCatalogo(query)
    }
  }

  openDiagramModal = (item) => {
    this.props.fetchDiagramDataRequest(item.codigodearticulo)
    this.setState({ diagramModalVisible: true, diagramModalItem: item })
  }

  closeDiagramModal = () => {
    this.setState({ diagramModalVisible: false, diagramModalItem: null })
  }

  render() {
    const {
      view,
      products,
      role,
      showSidePanel,
      showQuickCart,
      showEstimate,
      isMobile,
      t,
      isSearching,
    } = this.props

    if (isSearching) {
      return (
        <div className='spin-container'>
          <Spin size='large' style={{ display: 'block', margin: '50px auto' }} />
        </div>
      )
    }

    let showEstimateBtn = false
    let showAddToCartBtn = false
    let showFavoriteBtn = false
    const hideItems = showSidePanel || showQuickCart || showEstimate

    if (role == ROLES.CLIENT) {
      showEstimateBtn = true
      showAddToCartBtn = true
      showFavoriteBtn = true
    }

    if (role == ROLES.SALESMAN) {
      showAddToCartBtn = true
      showFavoriteBtn = true
    }

    const initData = {
      defaultCurrent: 1,
      current: products.page,
      pageSize: 12,
      total: products.totalCount !== undefined ? products.totalCount : 0,
      data: products.data !== undefined ? products.data : [],
    }

    const itemsClasses = []

    return (
      <div className='catalog-items'>
        {view === PRODUCTS_RESULT_MODE.GRID && products.data && (!hideItems || !isMobile) && (
          <div className={itemsClasses.join(' ')}>
            <div className='catalog-items-cards'>
              {initData.data.length > 0 ? (
                initData.data.map((product) => (
                  <CatalogItemCard
                    item={product}
                    key={product.codigodearticulo}
                    showEstimateBtn={showEstimateBtn}
                    showAddToCartBtn={showAddToCartBtn}
                    showFavoriteBtn={showFavoriteBtn}
                    onOpenDiagramModal={this.openDiagramModal}
                  />
                ))
              ) : (
                <Empty
                  className='mt-5'
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={t('No products')}
                />
              )}
            </div>

            {initData.total > 0 && (
              <div className='catalog-items-pagination'>
                <Pagination
                  defaultCurrent={initData.defaultCurrent}
                  current={initData.current}
                  total={initData.total}
                  pageSize={initData.pageSize}
                  onChange={this.handleProductPageChange}
                  showSizeChanger={false}
                />
              </div>
            )}
          </div>
        )}

        {view === PRODUCTS_RESULT_MODE.TABLE && products.data && (!hideItems || !isMobile) && (
          <div className={itemsClasses.join(' ')}>
            <div className='catalog-items-table statistics-div-table'>
              <CatalogItemsTable
                items={initData}
                onChange={this.handleProductPageChange}
                showEstimateBtn={showEstimateBtn}
                showAddToCartBtn={showAddToCartBtn}
                showFavoriteBtn={showFavoriteBtn}
                rowKey={(record) => record.codigodearticulo}
                isMobile={isMobile}
                onOpenDiagramModal={this.openDiagramModal}
              />
            </div>
          </div>
        )}
        {(!products || !products.data) && (
          <div className='catalog-items-default'>
            <CatalogItemDefault {...this.props} />
          </div>
        )}
        <DiagramModal
          visible={this.state.diagramModalVisible}
          onClose={this.closeDiagramModal}
          item={this.state.diagramModalItem}
          isMobile={isMobile}
        />
      </div>
    )
  }
}
const mapDispatchToProps = (dispatch) => ({
  getProductsByLineaCatalogo: (lineaCatalogoId, pageSize, page) => {
    dispatch(getProductsByLineaCatalogo(lineaCatalogoId, pageSize, page))
  },
  searchCatalogProducts: (data) => {
    dispatch(searchCatalogProducts(data))
  },
  setFilterSelected: (filter) => {
    dispatch(setFilterSelected(filter))
  },
  fetchDiagramDataRequest: (productCode) => {
    dispatch(fetchDiagramDataRequest(productCode))
  },
})

const mapStateToProps = ({ catalog, auth, userConfig, products: productReducer }) => {
  const role = getRolename(auth)
  const { viewResultMode: view } = userConfig.config
  const sortColumn = productReducer.sort
  const {
    products,
    selectedCatalogLine,
    showSidePanel,
    showQuickCart,
    showEstimate,
    searchRequest,
    isSearching,
    filterSelected,
  } = catalog
  return {
    view,
    products,
    sortColumn,
    selectedCatalogLine,
    showSidePanel,
    showQuickCart,
    showEstimate,
    role,
    searchRequest,
    isSearching,
    filterSelected,
    auth,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withTranslation()(
    withRouterParams(CatalogItems, {
      [PARAM_LINEACATALOGOID]: PARAM_LINEACATALOGOID,
      [PARAM_FILTER]: PARAM_FILTER,
      [PARAM_SORT]: PARAM_SORT,
    }),
  ),
)
